import { ChildrenModelBase } from './children-base.model';

export class Unit extends ChildrenModelBase {
    unitTypeId: number;
    facilityId: number;
    description: string;
}